import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Sprout } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(name.trim(), email.trim(), password);
      toast.success("Account created");
      nav("/app");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <div className="h-9 w-9 rounded-md bg-primary text-primary-foreground flex items-center justify-center"><Sprout size={18} /></div>
          <span className="heading font-semibold text-sm sm:text-base">Roots by Sanjeevani Farms</span>
        </Link>
        <h1 className="heading text-3xl font-semibold">Create account</h1>
        <p className="text-sm text-muted-foreground mt-1">Registers you as a plot owner. Admin can upgrade your role.</p>
        <div className="space-y-4 mt-8">
          <div>
            <Label htmlFor="name">Full name</Label>
            <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name-input" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email-input" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password-input" />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="register-submit-btn">
            {busy ? "Creating…" : "Create account"}
          </Button>
        </div>
        <div className="mt-6 text-sm text-muted-foreground">
          Already have one? <Link to="/login" className="text-primary font-medium">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
